import React, { Component } from "react"
import { Card, CardBody, Col, Label, Input, FormGroup, CardTitle, Button } from "reactstrap"
import {
    createNotificationHelpers,
    updateStoreBlocked,
} from "../utils";

export default class StoreBlocked extends Component {
    constructor(props) {
        super(props)
        this.state = {
            is_blocked: props.is_blocked || false,
            reason: props.reason || '',
            store_domain: props.store_domain || ''
        }

        const notifications = createNotificationHelpers();
        this.notify_info = notifications.notify_info;
        this.notify_error = notifications.notify_error;
        this.notify_success = notifications.notify_success;
    }

    componentDidUpdate(prevProps) {
        if (prevProps.is_blocked !== this.props.is_blocked) {
            this.setState({ is_blocked: this.props.is_blocked });
        }
        if (prevProps.reason !== this.props.reason) {
            this.setState({ reason: this.props.reason });
        }
    }

    handleChangeCheckbox = async () => {
        const answer = window.confirm("Are you sure you want to change the blocked status?");
        if (!answer) {
            return;
        }

        const storeData = {
            store_domain: this.props.store_domain,
            is_blocked: !this.state.is_blocked,
            reason: this.state.reason
        };

        const success = await updateStoreBlocked(
            storeData,
            this.notify_success,
            this.notify_error
        );

        if (success) {
            this.setState({ is_blocked: !this.state.is_blocked });
        }
    }

    handleReasonChange = (e) => {
        this.setState({ reason: e.target.value });
    }

    handleUpdateReason = async () => {
        const answer = window.confirm("Are you sure you want to update the blocked reason?");
        if (!answer) {
            return;
        }

        const storeData = {
            store_domain: this.props.store_domain,
            is_blocked: this.state.is_blocked,
            reason: this.state.reason
        };

        const success = await updateStoreBlocked(
            storeData,
            this.notify_success,
            this.notify_error
        );

        if (!success) {
            this.setState({ reason: this.props.reason || '' });
        }
    }

    render() {
        return (
            <React.Fragment>
                <Col xl={this.props.colSize}>
                    <Card className="shadow-sm">
                        <CardBody className="py-4">
                            <CardTitle tag="h6" className="mb-3 text-muted">
                                Store Blocked
                            </CardTitle>
                            <p className="text-muted small mb-3">
                                Block or unblock this store and provide a reason.
                            </p>
                            <FormGroup className="form-check form-switch mb-3 d-flex align-items-center justify-content-between py-2 px-3 rounded bg-light">
                                <Label
                                    htmlFor="store-blocked-switch"
                                    className="form-check-label mb-0 fw-normal"
                                >
                                    Is Blocked
                                </Label>
                                <Input
                                    type="checkbox"
                                    name="is_blocked"
                                    className="form-check-input"
                                    id="store-blocked-switch"
                                    onChange={this.handleChangeCheckbox}
                                    checked={this.state.is_blocked}
                                />
                            </FormGroup>
                            <FormGroup className="mb-0">
                                <Label htmlFor="blocked-reason" className="form-label">
                                    Reason
                                </Label>
                                <Input
                                    type="text"
                                    id="blocked-reason"
                                    name="reason"
                                    className="form-control mb-2"
                                    placeholder="Enter reason for blocking..."
                                    value={this.state.reason}
                                    onChange={this.handleReasonChange}
                                />
                                <Button 
                                    color="primary" 
                                    size="sm"
                                    onClick={this.handleUpdateReason}
                                    disabled={this.state.reason === (this.props.reason || '')}
                                >
                                    Update Reason
                                </Button>
                            </FormGroup>
                        </CardBody>
                    </Card>
                </Col>
            </React.Fragment>
        )
    }
}
